"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _basicSlider = require("./basicSlider");

var _basicSlider2 = _interopRequireDefault(_basicSlider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _basicSlider2.default;